'use client';

import React, { memo, useMemo } from 'react';
import AppImage from './AppImage';

interface AppLogoProps {
  /**
   * 'light' = cream/beige logo (logo-14) - use on dark backgrounds (header, footer, dark sections)
   * 'dark'  = crimson logo (logo-15)     - use on light/white backgrounds
   */
  variant?: 'light' | 'dark';
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  variant = 'light',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  // logo-15 = crimson/red logo (for light backgrounds)
  // logo-14 = cream/beige logo (for dark backgrounds)
  const src =
    variant === 'dark' ?'/assets/images/HCAF_2026_2_logo-15-1785142082683.png' :'/assets/images/HCAF_2026_2_logo-14-1785145845977.png';

  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  // Source logo art is a wide 4234x1185 (~3.57:1) wordmark, not square.
  // Treat `size` as the rendered width so the box matches the art's
  // aspect ratio instead of letterboxing it inside a square.
  const LOGO_ASPECT_RATIO = 4234 / 1185;
  const width = size;
  const height = Math.round(size / LOGO_ASPECT_RATIO);

  return (
    <div className={containerClassName} onClick={onClick}>
      <AppImage
        src={src}
        alt="HCAF - Hoyi Choyi Anondo Foundation"
        width={width}
        height={height}
        className="flex-shrink-0 object-contain"
        priority={true}
      />
    </div>
  );
});

export default AppLogo;
